import { useState, useEffect, useRef } from 'react'
import SectionTitle from '../../common/SectionTitle'
import Slick from 'react-slick'

import './_FeedbackSection.scss'

import avatar1 from '../../../assets/images/feedback-section/avatar-1.png'
import avatar2 from '../../../assets/images/feedback-section/avatar-2.png'
import avatar3 from '../../../assets/images/feedback-section/avatar-3.png'
import quote from '../../../assets/images/icons/quote.svg'
import twitter from '../../../assets/images/icons/twitter.svg'
import facebook from '../../../assets/images/icons/facebook.svg'

const FeedbackCard = ({ img, name, date, text }) => (
  <div className='gradient-border'>
    <div className='feedback-card gradient-border-content'>
      <div className='img-box'>
        <img src={img} alt={name} className='avatar' />
      </div>
      <span className='name'>{name}</span>
      <span className='date'>{date}</span>
      <div className='quote-icon center'>
        <img src={quote} alt='' className='icon' />
      </div>
      <p className='text'>{text}</p>
    </div>
  </div>
)

const feedbackCards = [{
  img: avatar1,
  name: 'Margaret Duchi',
  date: '12 Jun 2021',
  text: '“Best company!!! They are very professional and stay in contact to help you get started!!! The price was great as well!!!”',
  icon: twitter,
  socialLink:''
}, {
  img: avatar2,
  name: 'Kat Park',
  date: '12 Jun 2021',
  text: '“Having regular Reserch at moment and practice is professional, helpful and friendly. Always keeping me up to date with results and appointments.”',
  icon: facebook,
  socialLink:''
}, {
  img: avatar3,
  name: 'Sean Johnson',
  date: '12 Jun 2021',
  text: "“So far so good! The helpful and quality customer service, the easy doctor's visit, and the medication arriving on time and correct has made this a very smooth transition.”",
  icon: twitter,
  socialLink:''
}]

const FeedbackSection = () => {
  const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)
  const slider = useRef(null)

  const resizeWindow = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', resizeWindow)

    return () => window.removeEventListener('resize', resizeWindow)
  })

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <div className='FeedbackSection section-padding' id='review'>
      <div className='container'>
        <SectionTitle
          title='What our customers are saying'
          text='Experience that our clients have with us'
        />
        <div className='slider-box'>
          { windowWidth < 834 ?
            <Slick {...settings} ref={slider}>
              {feedbackCards.map(card => <FeedbackCard {...card} key={card.name} />)}
            </Slick> :
            feedbackCards.map(card => <FeedbackCard {...card} key={card.name} />)
          }
          <div className='slick-slider-arrows center-x'>
            <div className='arrow arrow-left' onClick={() => slider?.current?.slickPrev()}>
              <svg width="25" height="12" viewBox="0 0 25 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 5.59375L1.42836 5.59375" stroke="#386DF6" strokeWidth="2" strokeLinecap="round"/>
                <path d="M1.80705 5.92835L1.50452 5.59328L1.80705 5.25821L5.31016 1.37821C5.48496 1.18461 5.48763 0.832936 5.308 0.625975C5.1545 0.458262 4.93221 0.459055 4.77936 0.628352L0.635206 5.21835C0.454931 5.41802 0.454931 5.75854 0.635206 5.95821L4.77936 10.5482C4.93293 10.7183 5.15659 10.7183 5.31016 10.5482C5.49044 10.3485 5.49044 10.008 5.31016 9.80835L1.80705 5.92835Z" fill="white" stroke="#386DF6"/>
              </svg>
            </div>
            <div className='arrow arrow-right' onClick={() => slider?.current?.slickNext()}>
              <svg width="25" height="12" viewBox="0 0 25 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 5.58203L23.5716 5.58203" stroke="#386DF6" strokeWidth="2" strokeLinecap="round"/>
                <path d="M23.193 5.24743L23.4955 5.5825L23.193 5.91757L19.6898 9.79757C19.515 9.99117 19.5124 10.3428 19.692 10.5498C19.8455 10.7175 20.0678 10.7167 20.2206 10.5474L24.3648 5.95743C24.5451 5.75776 24.5451 5.41724 24.3648 5.21757L20.2206 0.627569C20.0671 0.457477 19.8434 0.457477 19.6898 0.627569C19.5096 0.827239 19.5096 1.16776 19.6898 1.36743L23.193 5.24743Z" fill="white" stroke="#386DF6"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeedbackSection
